//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import { BailetsBlock } from '../../ModalCopy.styles';
import { CloseVideoIcon, LogoMartins } from '@assets/svgs';
import SS25_Black_Brown_1 from '@assets/SS25_Black_Brown_1.png';
import SS25_pink_2 from '@assets/SS25_pink_2.png';
import SS25_pink_3 from '@assets/SS25_pink_3.png';
import SS25_brown_1 from '@assets/SS25_brown_1.png';
import skirtblack_1 from '@assets/skirtblack_1.png';
import momentum from '@assets/momentum.png';
import stripes from '@assets/stripes.png';

type CollectionProps = {
  isClosed?: () => void;
  showImg?: boolean | string;
  showMedia?: boolean | string;
};

export const FashionStylist = ({
  isClosed,
  showImg,
  showMedia
}: CollectionProps) => {
  return (
    <>
      <BailetsBlock>
        <Link className="closeIcon_A" href={'/'}>
          {' '}
          <CloseVideoIcon animation="closeIcon" color="#000" />
        </Link>
        {/* <CloseVideoIcon
          animation="closeIcon"
          color="#000"
          isActive={isClosed}
        /> */}
        <LogoMartins
          width={70}
          height={65}
          color="rgba(0,0,0,0.5)"
          animation="mansion"
        />

        <h3>MARTIN'S FASHION STYLIST</h3>
        <span style={{ marginBottom: '25px' }}>
          We are Fashion Stylists | SS 25 trends
        </span>
        {showImg && <Image src={showImg} width={1480} height={825} alt="" />}
        <Link style={{ textDecoration: 'underline' }} href={'/ads'}>
          Watch Collection Stories
        </Link>
        <Link
          style={{ textDecoration: 'underline', marginTop: '20px' }}
          href={'http://fass-hion.jorgedd.com/Story/'}
        >
          Visit FASS-HION Magazine
        </Link>
      </BailetsBlock>

      <BailetsBlock>
        <h3 style={{ marginTop: '25px' }}>Spring is here</h3>
        <h3>and Stripes too!</h3>
        <br />
        <Image src={stripes} width={1900} height={2525} alt="Ward 1" />
        <br />
        <p style={{ width: '100%' }}>
          <b>Top charm outfit for this Spring / Summer 2025 is right here!</b>
        </p>
        <p style={{ width: '100%' }}>
          This evening mini dress is the ultimate in sophistication and
          elegance. The sleek, fitted silhouette flatters the body and allows
          for ease of movement. The alternating white and blue vertical stripes
          create a striking and timeless pattern. The luxurious, slightly glossy
          fabric, like satin or silk, adds an element of glamour.
        </p>
        <p style={{ width: '100%' }}>
          The dress was designed for women over 30/40, highlighting white and blue
          stripes for a refined yet modern amd minimalist look.
        </p>
        <h3 className="subTitle">1. Overall Design & Silhouette</h3>
        <p style={{ width: '100%' }}>
          The dress has a sophisticated and structured silhouette, designed to
          flatter the figure while maintaining comfort.
          <br />
          <br />
          It combines classic elegance with a contemporary touch, making it
          versatile for both formal and semi-formal occasions.
          <br />
          <br />
          The length falls just below the knee or mid-calf, ensuring an
          age-appropriate yet stylish appeal.
        </p>
        <h3 className="subTitle">2. Fabric & Pattern</h3>
        <p style={{ width: '100%' }}>
          The dress is crafted from premium fabrics like silk, cotton-blend, or
          structured crepe for a polished finish.
          <br />
          <br />
          The white and blue stripes are strategically placed to create a
          slimming effect, with vertical or diagonal lines enhancing the figure.
          <br />
          <br />
          The stripe width varies—some sections feature thin, delicate lines,
          while others have bold, statement-making stripes.
        </p>
        <h3 className="subTitle">3. Neckline & Sleeves</h3>
        <p style={{ width: '100%' }}>
          The neckline is elegant yet modest, such as a boat neck, V-neck, or a
          tailored collar for added sophistication.
          <br />
          <br />
          The sleeves can be cap sleeves, three-quarter length, or full-length
          with slight transparency, depending on the style preference.
        </p>
        <h3 className="subTitle">4. Waist Detailing & Fit</h3>
        <p style={{ width: '100%' }}>
          A cinched waist or belted design defines the silhouette, creating a
          feminine and polished look.
          <br />
          <br />
          Some variations may include a wrap-style bodice, a fitted top with a
          flowing A-line skirt, or a structured sheath cut for a sleek
          aesthetic.
        </p>
        <h3 className="subTitle">5. Styling & Accessories</h3>
        <p style={{ width: '100%' }}>
          <b>Jewelry:</b> Minimalist silver or pearl accessories to complement
          the sophisticated stripes.
          <br />
          <br />
          <b>Shoes:</b> Nude, white, or navy-blue heels for an elegant finish.
          <br />
          <br />
          <b>Bag:</b> A structured clutch or a small handbag in neutral or
          matching tones.
          <br />
          <br />
          <b>Outerwear:</b> A tailored blazer or a lightweight trench coat for a
          chic layering option.
        </p>
        <h3 className="subTitle">Perfect for:</h3>
        <p style={{ width: '100%' }}>
        Business events, semi-formal gatherings, upscale brunches, and evening outings.<br/><br/>
        A great wardrobe staple that transitions effortlessly from day to night with the right accessories.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3 style={{ marginTop: '25px' }}>Get Ready to be</h3>
        <h3>the momentum Queen!</h3>
        <br />
        <Image src={momentum} width={1900} height={2525} alt="Ward 1" />
        <br />
        <p style={{ width: '100%' }}>
          You are the gemstone at your core! You are the choice of your own, and
          that is something to celebrate!
        </p>
        <p style={{ width: '100%' }}>
          This stunning evening dress is the ultimate blend of luxury and
          sophistication, designed for women over 30 who want to make a
          statement. The gown features a transparent sheer base in white,
          adorned with dazzling diamond embellishments that catch the light
          beautifully. Intricately embroidered black and green lace details add
          depth and contrast to the overall design, making this dress a real
          showstopper.
        </p>
        <p style={{ width: '100%' }}>
          The fitted bodice is simply stunning, showing off your figure
          beautifully, and the flowing skirt is so elegant, draping around you
          in a way that makes you feel like you're floating! The dress features
          the most delicate, sheer sleeves, which make it feel like you're
          wearing something straight out of a dream. To top it all off, the
          outfit is styled with some absolutely gorgeous accessories, like
          stunning diamond earrings, a sleek updo, and a minimalist clutch -
          it's the perfect look for a woman who wants to make a statement!
        </p>
        <p style={{ width: '100%' }}>
          This dress is absolutely perfect for a glamorous evening event! It
          exudes confidence, elegance and modern sophistication. I would love to
          know if you would like any refinements!
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3 style={{ marginTop: '25px' }}>Spread Confidence!</h3>
        <h3>Elegance is something else.</h3>
        <br />
        <Image src={skirtblack_1} width={1900} height={2525} alt="Ward 1" />
        <br />
        <p style={{ width: '100%' }}>
          The look for a modern and confident woman in spring-summer 2025.
        </p>
        <p style={{ width: '100%' }}>
          The outfit is incredibly stunning! The chic black midi skirt with a
          flowy silhouette is smashing, and the structured cream lightweight
          coat is the perfect way to look elegant yet relaxed. The sleek white
          blouse adds a touch of sophistication, while the black ankle boots add
          a touch of edginess. A cream leather handbag completes the ensemble,
          making it splendid for any occasion. The outfit is accessorised with
          minimal yet refined jewellery, making it perfect for a day out.
        </p>
        <p style={{ width: '100%' }}>
          <b>1- Black Midi Skirt Flowy silhouette:</b> Creates a refined and
          feminine movement.
          <br /> <b>High-waisted design:</b> Accentuates the waistline for a
          flattering fit.
          <br /> <b>Lightweight fabric (chiffon or crepe):</b> Perfect for the
          spring-summer season, offering comfort and breathability.
        </p>
        <p style={{ width: '100%' }}>
          <b>2- Elegant Cream Coat Longline and structured fit:</b> Adds polish
          and sophistication to the outfit.
          <br /> <b>Lightweight material (linen blend or soft wool):</b> Ideal
          for transitioning between seasons.
          <br /> <b>Subtle lapel details:</b> Enhances the timeless and chic
          look.
        </p>
        <p style={{ width: '100%' }}>
          <b>3- Sleek White Blouse Slim fit, tucked into the skirt:</b> Creates
          a balanced, put-together aesthetic.
          <br /> <b>Soft and breathable fabric (silk or satin):</b> Adds a
          luxurious touch.
          <br /> <b>Minimalist neckline (round or V-neck):</b>
          Keeps it elegant and versatile.
        </p>
        <p style={{ width: '100%' }}>
          <b>
            4- Stylish Black Ankle Boots Polished leather or suede material:
          </b>{' '}
          Elevates the overall look.
          <br /> <b>Slight heel or pointed-toe design:</b> Adds an extra touch
          of sophistication.
          <br /> <b>Versatile and comfortable:</b> Suitable for both day and
          evening wear.
        </p>
        <p style={{ width: '100%' }}>
          <b>5- Accessories & Details Structured Cream Leather Handbag:</b> A
          perfect complement to the neutral tones.
          <br />{' '}
          <b>Minimal Jewelry (gold or silver hoops, delicate bracelet):</b>{' '}
          Keeps the elegance understated.
          <br /> <b>Classic Sunglasses (cat-eye or round frames):</b> Enhances
          the chic city vibe.
        </p>
        <p style={{ width: '100%' }}>
          <b>6- Hair & Makeup Soft waves or sleek ponytail:</b> A timeless and
          polished hairstyle.
          <br /> <b>Natural makeup with a nude or soft pink lip:</b> Fresh and
          sophisticated.
        </p>
        <p style={{ width: '100%' }}>
          This outfit is the epitome of elegance meets modern minimalism, making
          it ideal for business casual settings, brunch, or an effortlessly chic
          city stroll. The white, cream, and black color palette ensures a
          timeless appeal, while the lightweight materials keep it comfortable
          for the summer ahead.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3 style={{ marginTop: '25px' }}>Modernity Fits You!</h3>
        {/* <h3>Fits You!</h3> */}
        <br />
        <Image src={SS25_brown_1} width={1900} height={2525} alt="Ward 1" />
        <br />
        <p style={{ width: '100%' }}>In every step you are the youth queen!</p>
        <p style={{ width: '100%' }}>
          <b>1- Well-Fitted Brown Jeans Slim or straight-leg cut:</b> Offers a
          flattering silhouette without being too tight or restrictive.
          <br />
          <b>High-waisted design:</b> Accentuates the waist and elongates the
          legs, creating a balanced and refined look.
          <br /> <b>Earthy brown tone:</b> A warm and versatile color that pairs
          well with neutrals.
          <br /> <b>Premium fabric blend:</b>
          Likely a mix of cotton and elastane for comfort and flexibility.
          <br />
          <b>Minimalistic details:</b> Clean-cut hems or subtle stitching to
          maintain a polished finish.
        </p>
        <p style={{ width: '100%' }}>
          <b>2- Cozy Yet Stylish White Hoodie Relaxed yet structured fit:</b>{' '}
          Not too oversized, ensuring a modern and chic appearance.
          <br />
          <b>Soft, high-quality fabric:</b> Likely a cotton or cashmere blend
          for warmth and breathability.
          <br /> <b>Minimalist design:</b> No excessive logos or patterns,
          keeping it sophisticated.
          <br /> <b>Ribbed cuffs and hem:</b> Adding a slight structure to the
          hoodie.
          <br /> <b>Slightly cropped or tucked-in style:</b> Enhances the waist
          definition when paired with high-waisted jeans.
        </p>
        <p style={{ width: '100%' }}>
          {' '}
          <b>
            3- Fashionable Brown and White Sport Shoes Chunky sole or sleek
            design:
          </b>
          Depending on the preference, it could be a trendy chunky sneaker or a
          sleek, minimal trainer.
          <br /> <b>Comfortable cushioning:</b> Ideal for all-day wear while
          maintaining a stylish look.
          <br /> <b>High-quality leather or mesh details:</b> Ensuring
          durability and breathability.
          <br /> <b>White base with brown accents:</b> A harmonious mix that
          complements the outfit.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3 style={{ marginTop: '25px' }}>Your style</h3>
        <h3>is your glee story!</h3>
        <br />
        <Image src={SS25_pink_3} width={1900} height={2525} alt="Ward 1" />
        <br />
        <p style={{ width: '100%' }}>
          Light Blue and Pink rewrite your biography!
        </p>
        <p style={{ width: '100%' }}>
          <b>Classic Trousers:</b> These trousers are tailored in a soft pink
          hue, offering a graceful straight-leg cut that ensures a sleek and
          elongated silhouette. Designed with lightweight fabric, they are
          perfect for warmer months. The trousers feature a refined waistband
          with minimal detailing and discreet pockets, combining functionality
          with elegance.
        </p>
        <p style={{ width: '100%' }}>
          <b>Coat:</b> The coat is crafted in a dreamy light blue shade,
          bringing freshness and charm to the ensemble. It showcases a
          structured yet lightweight design with a cinched waist, classic
          lapels, and a single-button closure for a polished look. Its
          breathable material makes it ideal for spring-summer wear while
          maintaining sophistication.
        </p>
        <p style={{ width: '100%' }}>
          <b>Ankle Boots:</b> Complementing the outfit, the ankle boots are
          designed in soft cream or pale pink tones, made of premium material
          for comfort and durability. Featuring a pointed toe and a subtle block
          heel, these boots add a touch of modernity while ensuring practicality
          for day-to-day wear.
        </p>
        <p style={{ width: '100%' }}>
          <b>Accessories:</b> For a cohesive finish, a slim belt in pink or blue
          can subtly accentuate the waist. Pair this with a structured handbag
          in light cream or a complementary soft blue to tie the look together.
          Delicate jewelry, such as a silver pendant necklace or minimalistic
          earrings, enhances the outfit’s overall elegance without overpowering
          its refined simplicity.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3 style={{ marginTop: '25px' }}>Femininity and Sophistication</h3>
        <h3>The perfect choice!</h3>
        <br />
        <Image src={SS25_pink_2} width={1900} height={2525} alt="Ward 1" />
        <br />
        <p style={{ width: '100%' }}>
          Comfort, Purity and Elegance! All together in your closet!
        </p>
        <p style={{ width: '100%' }}>
          <b>Classic Trousers:</b> These tailored trousers are crafted from a
          high-quality fabric in a soft pink hue. They offer a sleek,
          straight-leg cut that elongates the legs and provides a sophisticated
          silhouette. The trousers feature a tailored waistband with
          minimalistic detailing, discrete pockets, and a zip fly for a polished
          finish.
        </p>
        <p style={{ width: '100%' }}>
          <b>Coat:</b> The coat is a versatile piece designed from a luxurious,
          lightweight fabric, perfect for the spring-summer season. It comes in
          a light cream color that adds a touch of brightness and elegance to
          the outfit. The coat features a tailored silhouette with a slightly
          cinched waist, a classic lapel collar, and button closure. Practical
          elements include deep pockets and a comfortable lining.
        </p>
        <p style={{ width: '100%' }}>
          <b>Ankle Boots:</b> These ankle boots are both chic and comfortable,
          crafted from premium leather in a complementary light cream color.
          They feature a sleek design with a pointed toe and a modest heel that
          offers both elegance and practicality. The boots have a side zipper
          for easy wear and subtle detailing that adds sophistication.
        </p>
        <p style={{ width: '100%' }}>
          <b>Accessories:</b> To complete the look, consider adding stylish
          accessories. A statement belt in a matching pink color with a
          fashionable buckle can accentuate the waist and add an extra layer of
          detail to the trousers. A classic handbag in a complementary shade,
          such as pink or a contrasting neutral color, will provide both
          functionality and style. For a touch of glamour, a delicate necklace
          or a pair of elegant earrings can enhance the overall look without
          overwhelming it.
        </p>
        <p style={{ width: '100%' }}>
          <b>We Wrote it especially for you!</b>
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3 style={{ marginTop: '25px' }}>Get ready for a Week of Comfort</h3>
        <h3>Mystery and Elegance!</h3>
        <br />
        <Image
          src={SS25_Black_Brown_1}
          width={1900}
          height={2525}
          alt="Ward 1"
        />
        <br />
        <p style={{ width: '100%' }}>
          Black and Brown - Comfort, Mystery and Elegance. All in one to a
          powerful start of the week. Choose between brown mini trousers and
          trousers with a black top. Choose chic black ankle boots to match your
          perfection.
        </p>
        <p style={{ width: '100%' }}>
          <b>Mini Trousers:</b> The mini trousers are tailored to perfection,
          offering a sophisticated and contemporary look. They are crafted from
          a high-quality fabric in a rich black color, with subtle brown accents
          that add depth and dimension to the design. The trousers have a sleek,
          fitted silhouette that highlights the natural curves and provides a
          flattering fit. They feature a chic waistband with minimalistic
          detailing and discrete pockets for a polished finish.
        </p>
        <p style={{ width: '100%' }}>
          <b>Top:</b> The top is an elegant piece that complements the mini
          trousers beautifully. It comes in a complementary brown color,
          creating a harmonious contrast with the black trousers. The top is
          made from a luxurious fabric that drapes gracefully, providing both
          comfort and style. It features a tailored cut with a slightly cinched
          waist, a classic neckline, and subtle decorative stitching for an
          added touch of sophistication.
        </p>
        <p style={{ width: '100%' }}>
          <b>Footwear:</b> The footwear is both stylish and practical, designed
          to match the elegance of the outfit. Choose a pair of chic ankle boots
          in a matching black color, crafted from premium leather. They feature
          a sleek design with a pointed toe and a modest heel that provides both
          elegance and practicality. The boots have a side zipper for easy wear
          and subtle detailing that adds sophistication.
        </p>
        <p style={{ width: '100%' }}>
          <b>Accessories:</b> To complete the look, consider adding a few
          stylish accessories. A statement belt in black with a fashionable
          buckle can accentuate the waist and add an extra layer of detail to
          the trousers. A classic handbag in a neutral shade, such as beige or
          brown, will provide both functionality and style. For a touch of
          elegance, a delicate necklace or a pair of simple stud earrings can
          enhance the overall look without overwhelming it.
        </p>
      </BailetsBlock>
    </>
  );
};
